import { Constants } from 'resources/constants';
import { Resources as es } from 'resources/resources.es';
import { Resources as ca } from 'resources/resources.ca';
import { Resources as eu } from 'resources/resources.eu';
import { Resources as gl } from 'resources/resources.gl';
import { Resources as en } from 'resources/resources.en';

class ResourceManager {    

    constructor()
    { 
        // Se fusionan los idiomas con el español para las keys que no tienen traduccion
        this.dictionary = {
            'es-es': es,
            'ca-es': {...es, ...ca},
            'eu-es': {...es, ...eu},            
            'gl-es': {...es, ...gl},
            'en-gb': {...es, ...en}            
        };
        this.language =  Constants.Keys.DefaultLanguage;
    }  

    setLanguage(language) {  
        if(language == undefined){
            language =  Constants.Keys.DefaultVariant;
        }

        language = language.toLowerCase();
        if (this.dictionary[language]) {
            this.language = language;
        }
        else {
            this.language =  Constants.Keys.DefaultVariant;
        }
    }

    getResource(key) {   
        let ret = key;

        try {
            if (this.dictionary[this.language][key]) {
                ret = this.dictionary[this.language][key];
            } 
        } catch (error) {
        }

        return ret;
    }  
}

export let resourceManager = new ResourceManager();